import { type CheckboxProps } from './Checkbox.typed';
import * as Styled from './Checkbox.styled';
import React, { useEffect, useRef } from 'react';

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (props: CheckboxProps, ref) => {
    const { indeterminate, color, hasError, ...rest } = props;
    const myRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
      if (myRef && myRef.current) {
        myRef.current.indeterminate =
          typeof indeterminate !== 'undefined' ? indeterminate : false;
      }
    }, [ref, indeterminate]);

    return (
      <Styled.Wrapper color={color} hasError={hasError}>
        <input
          type="checkbox"
          ref={(node) => {
            myRef.current = node;
            if (typeof ref === 'function') {
              ref(node);
            } else if (ref) {
              ref.current = node;
            }
          }}
          {...rest}
        />
        <Styled.Checkbox hasError={hasError} />
      </Styled.Wrapper>
    );
  },
);

export default Checkbox;
